import React from 'react';
// we still need React 17's features to make the login page work
// eslint-disable-next-line react/no-deprecated
import { hydrate } from 'react-dom';

import App from 'src/components/App/App';
import { HydrateRouter } from 'src/components/HydrateRouter/HydrateRouter';
import { setEnvironment } from 'src/config';
import AuthProvider from 'src/modules/auth/AuthProvider';
import type { ClientContext } from 'src/types/sku';

export default ({ initialRoute, site, environment }: ClientContext) => {
  setEnvironment(environment);
  hydrate(
    <HydrateRouter initialRoute={initialRoute}>
      <AuthProvider>
        <App site={site} environment={environment} />
      </AuthProvider>
    </HydrateRouter>,
    document.getElementById('app'),
  );
};
